var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('languageSelector',{staticClass:"language"}),_c('img',{staticClass:"header__logo",attrs:{"src":_vm.logoFilename}}),_c('span',{staticClass:"header__text"},[_vm._v(" "+_vm._s(_vm.$t("xpo.shipment.title"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }